module.exports = __webpack_public_path__ + "static/landscape-05ccffa424e4af95838f0eed0c5f01f9.jpg";